import { difference } from 'lodash';
import store from '../../../Configs/Redux/Store';

export const havePermissions = (
  allows: Array<string>,
  permissions: Array<string> = [],
  hasAll = false
): boolean => {
  const userPermissions =
    permissions && permissions.length
      ? permissions
      : store.getState().App.user.roles;

  return hasAll
    ? difference(allows, userPermissions).length === 0
    : allows.some((allow) => userPermissions.includes(allow));
};
